import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { Account } from "@/types/api"

interface AuthState {
  token: string | null
  user: Account | null
  email: string | null
  loading: boolean
}

const initialState: AuthState = {
  token: null,
  user: null,
  email: null,
  loading: false,
}

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth: (state, action: PayloadAction<{ token: string; user: Account }>) => {
      state.token = action.payload.token
      state.user = action.payload.user
    },
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload
    },
    setUser: (state, action: PayloadAction<Account>) => {
      state.user = action.payload
    },
    setEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload
    },
    clearAuth: (state) => {
      state.token = null
      state.user = null
      state.email = null
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
  },
})

export const { setAuth, setToken, setUser, setEmail, clearAuth, setLoading } = authSlice.actions

export default authSlice.reducer
